import React, { useState,useEffect } from "react";
import "./studentLogin.css";
import { db,storage,auth } from "../../firebase";
import { doc,getDoc,updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Camera from "../../svg/Camers";
import Delete from "../../svg/Delete";
import Img from "../../svg/userimg.png";
import {ref,getDownloadURL,uploadBytes,deleteObject} from 'firebase/storage';
import Studentnav from "./Studentnav";

export default function Stuprofile() {
  const [img,setImg] = useState(''); 
  const [user,setUser] = useState();
  const navigate = useNavigate();
  useEffect(()=>{
      getDoc(doc(db, "users", auth.currentUser.uid)).then((docSnap) => {
          if (docSnap.exists) {
            setUser(docSnap.data());
          }
        });
    
      if(img){
          const uploadImg = async ()=>{
              const imgRef = ref(
                  storage,
                  `avatar/${new Date().getTime()} - ${img.name}`
              );
              try {
                  if(user.avatarPath){
                      await deleteObject(ref(storage,user.avatarPath)); //deletes the previous imgg from storage
                  }
                  const snap = await uploadBytes(imgRef,img);
                  // console.log(snap.ref.fullPath);
                  const url = await getDownloadURL(ref(storage,snap.ref.fullPath));
                  await updateDoc(doc(db,'users',auth.currentUser.uid),{
                      avatar:url,
                      avatarPath:snap.ref.fullPath,
                  });
                  setImg("");      
              } catch (err) {
                  console.log(err.message);
              }
             
              // console.log(snap.ref.fullPath);  gives path of the image we will need this when we will implement delete feature in img
              // console.log(url);  gives url of the img
              
          };
          uploadImg();        
      }
  },[img]);
  const deleteImg = async()=>{
      try{
         const confirm = window.confirm('Delete avatar?')
         if(confirm){
             await deleteObject(ref(storage,user.avatarPath));
             await updateDoc(doc(db,'users',auth.currentUser.uid),{
                 avatar:"",
                 avatarPath:"",
             });
             navigate("/stuhome");
         }
      }catch(err){
          console.log(err.message);
      }
  }
return user? (
   <>
    <Studentnav/>
   <section class="section about-section gray-bg " id="about">
   <div class="container">
       <div class="row align-items-center flex-row-reverse">
           <div class="col-lg-6">
               <div class="about-text go-to">
                   <h1 class="dark-color"><mark>{user.name}</mark></h1>
                   <h4 class="dark-color">About Me</h4>
                   <h6 class=" lead">{user.aboutme}</h6>
                   <div class="row about-list">
                                <div class="col-md-6">
                                <div class="media">
                               <label className="ctext">Email : </label>
                               <p className="ctext">{user.email}</p>
                           </div>
                           <div class="media">
                               <label className="ctext">CGPA : </label>
                               <p className="ctext">{user.cgpa}</p>
                           </div>
                                    <div class="media">
                               <label className="ctext">Location:  </label>
                               <p>&nbsp;&nbsp;</p>
                               <p className="ctext"> {user.address}</p>
                           </div>
                           <div class="media">
                               <label className="ctext">MIS Id :  </label>
                               <p className="ctext"> {user.misid}</p>
                           </div>
                                      <div class="media">
                               <label className="ctext">Department:</label>
                               <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                               <p className="ctext">&nbsp;&nbsp;{user.department}</p>
                           </div>
                                </div>
                                <div class="col-md-6">
                                <div class="media">
                               <label className="ctext">Class :  </label>
                               <p className="ctext"> {user.classes}</p>
                           </div>
                           {/* <div class="media">
                               <label className="ctext">Division :  </label>
                               <p className="ctext"> {user.division}</p>
                           </div> */}
                           <div class="media">
                               <label className="ctext">Contact :  </label>
                               <p className="ctext"> {user.contact}</p>
                           </div>
                           <div class="media">
                               <label className="ctext">Roll no. :  </label>
                               <p className="ctext"> {user.roll}</p>
                           </div>
                                   
                                </div>
                            </div>
                        
                    
                 
                   
               </div>
           </div>
           
           <div className="profile_container col-lg-6">
             <div className='img_container'>
              <img src={user.avatar || Img} alt="avatar" />
              <div className='overlay'>
                  <div>
                      <label htmlFor='photo'>
                          <Camera/>
                      </label>
                    {user.avatar? <Delete deleteImage={deleteImg}/>: null}
                     <input 
                     type="file" 
                     accept="image/*"
                    //  .pdf,.doc
                     style={{display:'none'}} 
                     id="photo"
                     onChange={(e)=>setImg(e.target.files[0])}
                     />
                 </div>
             </div>
             </div>
             </div>
           
       </div>
      
   </div>
</section></>

):null;
}